export default __webpack_public_path__ + "static/media/add-arrow.5dd218ea.svg";